var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDotsVertical = function SvgDotsVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#A4A7AE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M1.417 6.75a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333ZM1.417 2.083a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333ZM1.417 11.417a.667.667 0 1 0 0-1.334.667.667 0 0 0 0 1.334Z"
  })));
};
export default SvgDotsVertical;